import React from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { pathByRouteName } from '../../util/routes';

import { PrimaryButton } from '../Button/Button';
import NamedLink from '../NamedLink/NamedLink';

import css from './EmptyStateGuide.module.css';

/**
 * High-conversion empty state driven by onboardingCopy.emptyStates entries.
 *
 * @param {Object} props
 * @param {Object} props.config - Empty state object from getEmptyState()
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 */
const EmptyStateGuide = props => {
  const { config, className, rootClassName } = props;
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  if (!config?.title) {
    return null;
  }

  const classes = classNames(css.root, rootClassName, className);

  const handlePrimaryClick = () => {
    if (config.ctaRoute) {
      history.push(pathByRouteName(config.ctaRoute, routeConfiguration));
    }
  };

  return (
    <div className={classes} data-onboarding-id={config.id}>
      <h3 className={css.title}>{config.title}</h3>
      <p className={css.body}>{config.body}</p>
      <div className={css.actions}>
        {config.cta ? (
          <PrimaryButton
            className={css.primaryCta}
            onClick={handlePrimaryClick}
            disabled={!config.ctaRoute}
          >
            {config.cta}
          </PrimaryButton>
        ) : null}
        {config.secondaryCta && config.secondaryCtaRoute ? (
          <NamedLink name={config.secondaryCtaRoute} className={css.secondaryCta}>
            {config.secondaryCta}
          </NamedLink>
        ) : null}
      </div>
    </div>
  );
};

export default EmptyStateGuide;
